import { Action } from '@ngrx/store';
import { UserPreference } from '../../types/user-preferences.types';

export enum UserPreferencesActionTypes {
  Load = '[UserPreferences] Load',
  LoadSuccess = '[UserPreferences] Load Success',
  LoadFail = '[UserPreferences] Load Fail',
  Save = '[UserPreferences] Save',
  SaveSuccess = '[UserPreferences] Save Success',
  SaveFail = '[UserPreferences] Save Fail',
  Delete = '[UserPreferences] Delete',
  DeleteSuccess = '[UserPreferences] Delete Success',
  DeleteFail = '[UserPreferences] Delete Fail'
}

export class LoadUserPreferences implements Action {
  public readonly type = UserPreferencesActionTypes.Load;
}

export class LoadUserPreferencesSuccess implements Action {
  public readonly type = UserPreferencesActionTypes.LoadSuccess;

  constructor(public payload: UserPreference[]) {}
}

export class LoadUserPreferencesFail implements Action {
  public readonly type = UserPreferencesActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export class SaveUserPreference implements Action {
  public readonly type = UserPreferencesActionTypes.Save;
  constructor(public payload: UserPreference) {}
}

export class SaveUserPreferenceSuccess implements Action {
  public readonly type = UserPreferencesActionTypes.SaveSuccess;

  constructor(public payload: UserPreference) {}
}

export class SaveUserPreferenceFail implements Action {
  public readonly type = UserPreferencesActionTypes.SaveFail;

  constructor(public payload: string) {}
}

export class DeleteUserPreference implements Action {
  public readonly type = UserPreferencesActionTypes.Delete;
  constructor(public payload: string) {}
}

export class DeleteUserPreferenceSuccess implements Action {
  public readonly type = UserPreferencesActionTypes.DeleteSuccess;

  constructor(public payload: UserPreference[]) {}
}

export class DeleteUserPreferenceFail implements Action {
  public readonly type = UserPreferencesActionTypes.DeleteFail;

  constructor(public payload: string) {}
}

export type UserPreferencesActionsUnion =
  | LoadUserPreferences
  | LoadUserPreferencesFail
  | LoadUserPreferencesSuccess
  | SaveUserPreference
  | SaveUserPreferenceSuccess
  | SaveUserPreferenceFail
  | DeleteUserPreference
  | DeleteUserPreferenceSuccess
  | DeleteUserPreferenceFail;
